import { whenever } from '@vueuse/core';
import { type MaybeRefOrGetter, toRef } from 'vue';

import { useAsyncData } from '@abaninja/util-store';

import { useDeepboxStore } from '../stores/useDeepboxStore';

export function useDeepboxStatus(accountUuid: MaybeRefOrGetter<string | undefined>) {
  const deepboxStore = useDeepboxStore();

  const { execute } = useAsyncData(deepboxStore.getEntity, { immediate: false });

  whenever(toRef(accountUuid), execute, { immediate: true });

  return {
    ...deepboxStore,
    execute,
  };
}
